import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';
import noNotifications from '../../../assets/svg/no-notif.svg';

import notesIcon from '../../../assets/svg/notes-icon.svg';

import PatientNotesPreview from '../../../components/patientNotesPreview';


import moment from 'moment';
import { API_ENDPOINT, getAgeLimit, translateAgeLimitMessage } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import EventMeetingsModal from '../../../components/eventMeetingsModal';
import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';

import striptags from 'striptags';
import DoctorListComponent from '../../../components/forms/fields/doctorListComponent';
import InfoModal from '../../../components/infoModal';
import PatientModal from './patientModal';
import AddSecondParentModal from '../../../components/addSecondParentModal';
import { addMinutesToTime } from '../helper';
import PaymentMethodsField from '../../payments/components/paymentMethodsField';
import { getExtendedPaymentManagement } from '../../payments/helper';

function isTimeValidString(timeString) {
    let valid = false;
    if (timeString?.length === 5) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            valid = true;
        }
    }


    return valid;
}


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class ScheduleControl extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,
            errorAdditionalDoctors: null,
            visitReasons: [],
            revisitForms: [],
            revisitFormsSelected: [],
            revisitFormsSelect: [],
            journalNoteFormSelected: null,
            creatingEvent: false,
            searchByNameAndEmail: false,
            doctors: [],
            languages: [],
            clinicians: [],
            minTime: '07:00',
            maxTime: '18:00',
        }
        this.state.min = new Date();
        this.state.min.setHours(7, 0, 0)
        this.state.max = new Date();
        this.state.max.setHours(18, 0, 0)
    }

    getWorkingHours = () => {
        const doctorId = this.state.doctorId;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTime) {
                setObj.minTime = minTime;
            }
            if (maxTime !== this.state.maxTime) {
                setObj.maxTime = maxTime;
            }
            if (Object.keys(setObj).length > 0) {
                this.setState(setObj)
            }

        })
    }


    stopAnimation = () => {
        this.player.current.play();
    };



    setInitialData = () => {
        this.getRevisitQuestionary();
        this.getPriceList();
        this.getDoctors();
        this.getLanguages();
        this.getClinicians();
    }
    getLanguages = () => {

        fetch(API_ENDPOINT + '/languages', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                sortType: 1,
                sortField: 'key',
                query: {}
            })
        }).then(parseJSON).then(({ result, status }) => {
            if (result) {
                this.setState({ languages: result })
            }
        })

    }

    getDoctors = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.state.doctorId, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/subaccounts/doctors', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: null,
                entries: null,
                filter: query.filter,
                sortType: query.sortType,
                sortField: query.sortField,
                groupId: query.group,
                clinic: query.clinic,
                query: queryFields
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ doctors: result })
            }
        })


    }
    getPriceList = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.props.uData?._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/price-list/all', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({

                group: query.group,
                clinic: query.clinic,
                query: queryFields,
                filter: query.filter
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ visitReasons: result }, () => {
                    if (this.state.data?.patient) {
                        this.patientAge(this.state.data?.patient, () => this.setVisitReasonFromTemplate())
                    } else {
                        this.setVisitReasonFromTemplate();
                    }
                })
            }
        })

    }
    getClinicians = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ clinicians: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.clinicians?.length) {
                    this.setState({ clinicians: result.clinicians }, () => {
                        // if (!this.state.doctorId && this.props.doctorId && this.state.clinicians?.find(el => el._id === this.props.doctorId)) {
                        //     this.setState({ doctorId: this.props.doctorId });
                        // }
                    });
                }
            })
        });
    }
    fetchAvailabilityTemplates = () => {
        this.setState({ availabilityTemplates: [] }, () => {
            fetch(API_ENDPOINT + '/data/availability-templates/data/fetch', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    userId: this.state.doctorId,
                    groupId: this.props.selectedGroup,
                    clinicId: this.props.selectedClinic
                })
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.items?.length) {
                    this.setState({ availabilityTemplates: result.items })
                }
            })
        })
    }
    setInitialSelectOptions = () => {
        let selectOptions = this.state.selectOptions;
        for (let i = 1; i <= 20; i++) {
            selectOptions.instances.push(i)
        }
        for (let i = 0; i <= 90; i += 5) {
            selectOptions.gap.push(i)
        }
        this.setState({ selectOptions })
    }
    fetchWebBookingForms = () => {
        if (this.state.doctorId) {
            this.setState({ webBookingForms: [] }, () => {
                fetch(API_ENDPOINT + '/working-hours/web-booking-forms', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        doctor: this.state.doctorId,
                        group: this.props.selectedGroup,
                        clinic: this.props.selectedClinic
                    })
                }).then(parseJSON).then(({ result, status }) => {
                    if (result?.length) {
                        this.setState({ webBookingForms: result })
                    }
                })
            })
        }


    }




    componentDidMount() {

        if (this.props.isOpen) {
            let data = this.props.isOpen;
            if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
                let initialTime = this.generateInitialTime();
                data = {
                    ...initialTime,
                    ...data
                }
            }
            const doctorId = data?.doctor ?? null;
            this.setState({ data: data, doctorId }, () => {
                this.setInitialData();

                if (this.state.data?.patientData?._id) {
                    this.patientAge(this.state.data.patientData._id)
                }

            })
        }

    }
    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.isOpen !== this.props.isOpen) {
        //     let data = this.props.isOpen;
        //     if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
        //         let initialTime = this.generateInitialTime();
        //         data = {
        //             ...initialTime,
        //             ...data
        //         }
        //     }

        //     this.setState({ data: data })
        // }

        const { data } = this.state;

        if (JSON.stringify(prevState.data) !== JSON.stringify(data)) {
            this.checkPatientNotes();
        }

    }
    componentWillUnmount() {

    }

    toggle = (notToggle = false) => {
        this.setState({
            // data: !this.state.data,
            age: null,
            patient: null,
            doctorsList: [],
            revisitFormsSelected: [],
            revisitFormsSelect: [],
            journalNoteFormSelected: null
        }, () => {
            if (this.props.toggle) {
                this.props.toggle(notToggle);
            }
        })

    }
    formatDate = (date, format) => {
        if (!date || !format) return '';
        let dateString = date?.split(' ')?.[0];
        let timeString = date?.split(' ')?.[1];

        let DD = dateString?.split('/')[1];
        let MM = dateString?.split('/')[0];
        let YYYY = dateString?.split('/')[2];
        let HH = timeString?.split(':')[0];
        let mm = timeString?.split(':')[1];

        let formattedDate = format
            .replace('DD', DD)
            .replace('MM', MM)
            .replace('YYYY', YYYY)
            .replace('HH', HH)
            .replace('mm', mm);

        return formattedDate;

    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }


    setData = (data, callback) => {
        this.setState({ data }, () => {
            if (callback) {
                callback();
            }
        })
    }
    checkSSN = (ssn) => {
        fetch(API_ENDPOINT + '/users/patient/check/ssn', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                group: this.props.selectedGroup,
                clinic: this.props.selectedClinic,
                socialSecurityNumber: ssn
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ socialSecurityNumberExist: result.exist, ssnExistInThisGroup: result.ssnExistInThisGroup, needsParent: result.needsParent, hasParent: result.hasParent }, () => {
                    const _ageLimitFix = this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && this.state.needsParent && !this.state.hasParent ? true : false;
                    if (this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup) {
                        fetch(API_ENDPOINT + '/users/subaccounts/get', {
                            method: 'POST',
                            headers: {
                                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify({ socialSecurityNumber: ssn, group: this.props.selectedGroup, clinic: this.props.selectedClinic })
                        }).then(parseJSON).then(({ result, status }) => {
                            if (status == 200 && result && result.userData) {

                                this.props.changeName(result.userData.name);
                                this.props.changeSex(result.userData.sex);
                                if (!_ageLimitFix) this.props.changeEmail(result.email)
                                if (!_ageLimitFix) this.props.changePhone(result.phone)

                                if (result.parentObj) {
                                    this.props.changeSocialSecurityNumberParent(result.parentObj.socialSecurityNumber)
                                    this.props.changeNameParent(result.parentObj.name);
                                    this.props.changeEmail(result.parentObj.email);
                                    if (result.parentObj.userData.sex)
                                        this.props.changeSexParent(result.parentObj.userData.sex);
                                    this.props.changeLanguage(result.parentObj.language);
                                    this.props.changePhone(result.parentObj.phone);
                                }

                            }
                        })
                    }
                })
            }

        })
    }
    findPatient = (ssn) => {
        if (!ssn) {
            if (this.state.patientSocialSecurityNumber) {
                ssn = this.state.patientSocialSecurityNumber;
            } else {
                return;
            }
        }

        if (ssn) {
            this.checkSSN(ssn)
        }

        this.setState({ patient: null, age: null }, () => {
            fetch(API_ENDPOINT + '/users/find/patient', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    socialSecurityNumber: ssn
                })
            }).then(res => res.json()).then((result) => {
                //result = result?.error ? result?.error : result?.length ? result[0] : null;
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    if (result && result.name && result.socialSecurityNumber) {
                        let data = this.state.data;
                        data.patientData = result;
                        this.setState({
                            data
                        }, () => {
                            if (this.state.data?.patientData?._id) {
                                this.patientAge(this.state.data.patientData._id)
                            }
                        })
                    } else {
                        const groupData = this.getGroupData();

                        let enterprise = groupData.enterprise;
                        let canSearchPatients = groupData.sarchPatients;

                        if (enterprise || canSearchPatients) {
                            this.setState({
                                errorPatientNotFound: 'Check digits or register a new patient'.translate(this.props.lang)
                            }, () => {
                                this.patientAge(ssn)
                            })
                        } else {
                            this.setState({
                                error: 'The patient you are searching can not be found in your clinic'.translate(this.props.lang)
                            })
                        }

                    }

                }

            })
        })

    }
    patientAge = (data, callback) => {

        let country = this.state.countryStateDict?.['search-ssn'] ?? this.props.country;

        fetch(API_ENDPOINT + '/users/users/get-age/' + data, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                socialSecurityNumber: this.state.patientSocialSecurityNumber,
                country
            })
        }).then(res => res.json()).then((result) => {
            this.setState({
                age: result.age
            }, () => {
                if (callback) {
                    callback();
                }
            })
        })
    }
    getRevisitQuestionary = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.state.doctorId, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }


        fetch(API_ENDPOINT + '/data/revisit-questionary/all', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({

                group: query.group,
                clinic: query.clinic,
                query: queryFields,
                filter: query.filter
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ revisitForms: result })
            }
        })

    }
    checkDoctorsAvailable = (doctorsList, modal, callback) => {
        let event;
        event = this.state.data;

        if (doctorsList) {
            let data = {
                doctorsList: doctorsList,
                startEventReservedDateOriginal: event.date + ' ' + event.startTime,
                endEventReservedDateOriginal: event.date + ' ' + event.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                eventId: event.id
            }
            fetch(API_ENDPOINT + '/working-hours/check/doctors', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        errorAdditionalDoctors: result.doctorsList
                    })
                } else {
                    this.setState({ doctorsModal: false, successfullyAdditionalDoctors: modal != 4 ? true : false }, () => {
                        // if (modal == 1) {
                        //     let updateEvent = this.state.updateEvent;
                        //     updateEvent.additionalDoctors = this.state.doctorsList;
                        //     this.setState({ updateEvent })
                        // } else if (modal == 2) {
                        //     let scheduleReferral = this.state.scheduleReferral;
                        //     scheduleReferral.additionalDoctors = this.state.doctorsList;
                        //     this.setState({ scheduleReferral })
                        // } else if (modal == 3) {
                        //     let data = this.state.data;
                        //     data.additionalDoctors = this.state.doctorsList;
                        //     this.setState({ data })
                        // }
                        let data = this.state.data;
                        data.additionalDoctors = this.state.doctorsList;
                        this.setState({ data })


                    })
                }
                if (callback) {
                    callback();
                }


            })
        }


    }
    setVisitReasonFromTemplate = () => {
        let scheduleControl = this.state.data;

        if (scheduleControl?.templateData) {
            const data = scheduleControl.templateData;

            if (data?.selectedAvailabilityTemplate?.visitType) {
                let visitReasons = this.state.visitReasons?.items ?? [];
                let visitReason = visitReasons.find(obj => obj._id === data.selectedAvailabilityTemplate.visitType);
                if (visitReason) {
                    const groupData = this.getGroupData();

                    const enterprise = groupData?.enterprise;

                    scheduleControl.visitReasonName = visitReason.name;
                    if (this.state.age && visitReason.under18 && this.state.age < 18) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 4
                    } else if (this.state.age && visitReason.under20 && this.state.age < 20) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 3
                    } else if (this.state.age && visitReason.under23 && this.state.age < 23) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 2
                    } else if (this.state.age && visitReason.under18child && this.state.age < 18) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 6
                    } else if (this.state.age && visitReason.older85 && this.state.age > 85) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 5
                    } else {
                        scheduleControl.visitReasonPrice = visitReason.price;
                    }

                    scheduleControl.visiReason = visitReason._id;
                    scheduleControl.visitReasonOnline = visitReason.onlineVisit;
                    scheduleControl.videoCall = visitReason.videoCall;

                    let setObj = { selectVisitReason: false, data: scheduleControl };
                    let revisitFormsSelected = [];
                    let journalNoteFormSelected = null;

                    if (enterprise && visitReason && visitReason.defaultForm && this.state.revisitForms && this.state.revisitForms.items?.filter(el => el._id === visitReason.defaultForm).length) {
                        revisitFormsSelected.push(visitReason.defaultForm);
                        journalNoteFormSelected = visitReason.defaultForm;

                    }
                    setObj.journalNoteFormSelected = journalNoteFormSelected;
                    setObj.revisitFormsSelected = revisitFormsSelected;
                    this.setState(setObj)

                }
            }
        }
    }
    scheduleControl = (data, checkPreScheduleInfo = false) => {
        if (Number(data.visitReasonPrice) > 0 && Number(data._visitReasonPrice) === 0 && this.state.isPaymentMethodErrorShow) {
            this.setState({ showPaymentMethodError: true, creatingEvent: false });
            return;
        }
        if (!this.state.doctorId) {
            this.setState({ creatingEvent: false })
            return;
        }
        const _data = JSON.parse(JSON.stringify(data));
        let checkDate = new Date(data?.date?.replace(/-/g, "/") + ' ' + data?.startTime);
        let today = new Date();

        let templateData;
        if (data.templateData) {
            templateData = {};
            templateData._id = data.templateData?.id;
            templateData.scheduleKey = data.templateData?.scheduleKey;
            if (data.templateData?.startTime !== data.startTime || data.templateData?.endTime !== data.endTime) {
                templateData.startTime = data.templateData?.startTime;
                templateData.endTime = data.templateData?.endTime;
                templateData.changedTime = true;
            }

        }
        data.journalNoteFormSelected = this.state.journalNoteFormSelected;
        if (data.controlSchedule) {
            data.patientControlNote = data.patientNote;
            data.title = data.controlSchedule.event && data.controlSchedule.event.title;
            data.socialSecurityNumber = data.controlSchedule.patient ? data.controlSchedule.patient.socialSecurityNumber : '';
            data.visitReasonOnline = data.controlSchedule.event && data.controlSchedule.event.visitReasonOnline;
            data.videoCall = data.controlSchedule.event && data.controlSchedule.event.videoCall;
            data.titleDoctor = '';
            data.revisitForms = data.controlSchedule.event && data.controlSchedule.event.revisitForms;
            data.visitReasonName = data.controlSchedule.event && data.controlSchedule.event.visitReasonName;
            data.visitReasonPrice = data.controlSchedule.event && data.controlSchedule.event.questionaryPrice ? data.controlSchedule.event.questionaryPrice : 0;
            data.visiReason = data.controlSchedule.event && data.controlSchedule.event.visiReason;
            data.hideTimeFromThePatient = data.controlSchedule.event && data.controlSchedule.event.hideTimeFromThePatient;
            // data.hideDurationForPatient = data.controlSchedule.event && data.controlSchedule.event.hideDurationForPatient;
            data.closeCaseManually = data.controlSchedule.event && data.controlSchedule.event.closeCaseManually;
            data.referralExists = data.controlSchedule ? data.controlSchedule._id : '';
            data.appointmentPaid = data.controlSchedule.event.appointmentPaid ? data.controlSchedule.event.appointmentPaid : false;
            data.revisitFormsArray = data.controlSchedule.event.revisitFormsArray ? data.controlSchedule.event.revisitFormsArray : [];
            data.journalNoteFormSelected = data.controlSchedule.event.journalNoteFormSelected ? data.controlSchedule.event.journalNoteFormSelected : null;
            data.visitReasonOnline = data.controlSchedule.event.onlineVisit ? data.controlSchedule.event.onlineVisit : false;
            data.selectedParents = data.controlSchedule?.event?.selectedParents ?? null;
            data.rescheduleRevisit = data.rescheduleRevisit ? true : false;

        }
        let noteToPatient;
        if (data?.noteToPatient?.trim()) {
            noteToPatient = {
                note: data.noteToPatient,
                sendNoteAsPatientNotification: data.sendNoteAsPatientNotification ? true : false
            }

            if (data.sendNoteAsPatientNotification && !checkPreScheduleInfo) {
                this.setState({ noteToPatientPreScheduleInfo: { data: _data } })
                return;
            }
        }
        if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {
                // this.scheduleControlApiCalled = true;

                let obj = {
                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    title: data.title,
                    socialSecurityNumber: data.socialSecurityNumber,
                    doctor: this.state.doctorId,
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    patientControlNote: data.patientControlNote,
                    onlineVisit: data.visitReasonOnline,
                    videoCall: data.videoCall,
                    additionalDoctors: data.additionalDoctors,
                    titleDoctor: data.titleDoctor,
                    revisitForms: data.revisitForms ? data.revisitForms : this.state.revisitFormsSelected,
                    visitReasonName: data.visitReasonName,
                    visitReasonPrice: data.visitReasonPrice,
                    visiReason: data.visiReason,
                    freePayment: data.freePayment,
                    hideTimeFromThePatient: data.hideTimeFromThePatient,
                    hideDurationForPatient: data.hideDurationForPatient,
                    closeCaseManually: data.closeCaseManually,
                    referralExists: data.referralExists ? data.referralExists : null,
                    appointmentPaid: data.appointmentPaid ? data.appointmentPaid : false,
                    revisitFormsArray: data.revisitFormsArray ? data.revisitFormsArray : [],
                    journalNoteFormSelected: data.journalNoteFormSelected,
                    rescheduleRevisit: data.rescheduleRevisit,
                    selectedParents: data.selectedParents,
                    guests: data.guests,
                    templateData: templateData,
                    noteToPatient: noteToPatient,
                    wrongDate: checkDate >= today,
                    paymentMethods: data.paymentMethods,
                    attachedInvoice: data.attachedInvoice,
                    _visitReasonPrice: data?._visitReasonPrice

                };
                fetch(API_ENDPOINT + '/working-hours/control', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(obj)
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false
                        })
                    } else {
                        this.toggle(result.invoiceMessage ? true : false)
                        // if (data.controlSchedule) {
                        //     this.setState({
                        //         scheduleReferral: null,
                        //         doctorsList: [],
                        //         updateEventTemplate: null,
                        //         referralId: null
                        //     }, () => this.toggle(result.invoiceMessage ? true : false))
                        // } else {
                        //     this.setState({
                        //         scheduleModal: null,
                        //         referralId: null,
                        //         scheduleControl: null,
                        //         patient: null,
                        //         age: null,
                        //         revisitFormsSelected: [],
                        //         revisitFormsSelect: [],
                        //         journalNoteFormSelected: null,
                        //         updateEventTemplate: null,
                        //         doctorsList: []

                        //     }, () => {
                        //         this.toggle(result.invoiceMessage ? true : false)
                        //     })
                        // }

                        if (result.invoiceMessage) {
                            this.setState({
                                invoiceMessage: result.invoiceMessage
                            })
                        }

                    }
                    this.setState({
                        creatingEvent: false
                    })

                })
            })
        } else {
            this.setState({
                wrongDate: true,
                creatingEvent: false
            })
        }
    }
    checkPatientNotes = () => {
        const { data } = this.state;
        let patientId, patientSSN, eventId, referralId;
        if (data && (data?.patient || data?.socialSecurityNumber)) {
            if (data?.patient) patientId = data.patient;
            if (data?.socialSecurityNumber) patientSSN = data.socialSecurityNumber;
        }
        if (!patientId && !patientSSN && !eventId && !referralId) {
            this.setState({ patientNotes: [] })

            return;
        }
        let obj = {
            patientId,
            patientSSN,
            eventId,
            referralId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };

        this.setState({ patientNotes: [] }, () => {
            fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(res => res.json()).then((result) => {
                if (result?.items?.length) {
                    this.setState({ patientNotes: result.items });
                }
            })
        })

    }


    render() {
        const isOpen = this.props.isOpen ? true : false;
        if (!isOpen || !this.state.data) return null;

        const groupData = this.getGroupData();
        const enterprise = groupData?.enterprise;
        const eventMeetings = groupData?.eventMeetings ?? false;

        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);

        // const visitTemplates = groupData?.visitTemplates ?? null;
        // const availabilityTemplatesEnabled = this.state.availabilityTemplates?.length && visitTemplates ? true : false;

        // const eventMeetings = groupData?.eventMeetings ?? false;
        // const availabilityInformationToClinicians = groupData?.bookingSettings?.availabilityInformationToClinicians ?? null;

        // const doctorId = this.state.doctorId ?? null;

        // const disabledSaveButton = doctorId && this.state.data && this.state.data.type &&
        //     (this.state.data?.type !== 'template' || (this.state.data?.type === 'template' && this.state.data?.selectedAvailabilityTemplate?.id))
        //     && (!this.state.data.frequencyType || (this.state.data.frequencyType &&
        //         (this.state.data.frequencyType == 'day' && this.state.data.frequencyDayText && this.state.data.frequencyDayScheduledDateFrom && this.state.data.frequencyDayScheduledDateTo)
        //         || (this.state.data.frequencyType == 'month' && this.state.data.frequencyMonthScheduled && this.state.data.frequencyMonthScheduledDateFrom && this.state.data.frequencyMonthScheduledDateTo)
        //         || (this.state.data.frequencyType == 'week' && (this.state.data.checkedMonday || this.state.data.checkedTuesday || this.state.data.checkedThursday || this.state.data.checkedWednesday || this.state.data.checkedFriday || this.state.data.checkedSaturday || this.state.data.checkedSunday) && this.state.data.frequencyWeekScheduledDateFrom && this.state.data.frequencyWeekScheduledDateTo)
        //     )) && !this.state.creatingEvent
        //     ? false : true;

        const AGE_LIMIT = getAgeLimit(this.props.country, this.props.selectedGroup, this.props.clinicsAgeLimitExceptions);
        const isChild = typeof this.state.age === 'number' && this.state.age < AGE_LIMIT ? true : false;

        const msg = translateAgeLimitMessage(
            "Child is under {AGE_LIMIT} years of age - Account must be connected to a parent- or legal guardian account.",
            this.props.lang,
            AGE_LIMIT
        );
        const msg2 = translateAgeLimitMessage(
            "Child is under {AGE_LIMIT} years of age - Appointments are handled by parent or legal guardian.",
            this.props.lang,
            AGE_LIMIT
        );

        const patientData = this.state.data?.patientData ?? null;

        const doctorId = this.state.doctorId ?? null;
        const doctorData = this.state.clinicians?.find(el => el._id === doctorId);
        const disabledDoctorSelect = this.props.isOpen?.doctor && this.props.isOpen?.disabledDoctorSelect !== false ? true : false;

        const { minTime, maxTime } = this.state;
        return (
            <>

                <Modal isOpen={isOpen} centered>
                    <ModalHeader
                        toggle={() => this.toggle()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>
                        }
                    >
                        {'Schedule control'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody>
                        <FormGroup>
                            <Label>{'Doctor'.translate(this.props.lang) + '*'}</Label>
                            <Input type='select' value={doctorId} disabled={disabledDoctorSelect} onChange={(e) => {
                                let value = e.target.value;
                                if (value === '-1') value = null;
                                this.setState({ doctorId: value }, () => {
                                    this.getWorkingHours();
                                    let data = this.state.data;
                                    if (this.state.doctorId && data?.additionalDoctors?.find(el => el === this.state.doctorId)) {
                                        data.additionalDoctors = data.additionalDoctors.filter(el => el !== this.state.doctorId);
                                        this.setData(data);
                                    }
                                    if (this.state.doctorId && this.state.doctorsList?.find(el => el === this.state.doctorId)) {
                                        let doctorsList = this.state.doctorsList;
                                        doctorsList = doctorsList.filter(el => el !== this.state.doctorId);
                                        this.setState({ doctorsList })
                                    }
                                })

                            }}>
                                <option value={'-1'}>{'Select doctor'.translate(this.props.lang)}</option>
                                {
                                    this.state.clinicians.map((item, idx) => {
                                        return (
                                            <option value={item._id} key={idx}>{item.name}</option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                        <div className='schedule-control-find-patient-wrap'>

                            <FormGroup>
                                <Button
                                    color='primary'
                                    onClick={() => {
                                        if (this.props.findPatient) {
                                            this.props.findPatient({ ...this.state.data, doctor: this.state.doctorId, disabledDoctorSelect: disabledDoctorSelect }, null)
                                        }

                                    }}
                                >
                                    {'Find patient'.translate(this.props.lang)}
                                </Button>
                            </FormGroup>
                            {
                                this.state.data?.templateData?.selectedAvailabilityTemplate?._id && this.state.data?.patient && this.state.data?.patient === patientData?._id ?
                                    <div className='schedule-control-patient-info-wrap'>
                                        <div className='schedule-control-patient-info-item-wrap'>
                                            {
                                                patientData?.userData?.name || patientData?.name ?
                                                    <>
                                                        <h6>{'Name'.translate(this.props.lang)}</h6>
                                                        <h5>{patientData?.userData?.name ?? patientData?.name}</h5>
                                                    </>
                                                    :
                                                    null
                                            }
                                        </div>
                                        <div className='schedule-control-patient-info-item-wrap'>
                                            {
                                                patientData?.socialSecurityNumber ?
                                                    <>
                                                        <h6>{'Social security number'.translate(this.props.lang)}</h6>
                                                        <h5>{patientData?.socialSecurityNumber}</h5>
                                                    </>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                        {
                            this.state.data?.templateData?.selectedAvailabilityTemplate?._id ?
                                <div className='schedule-control-booking-information-wrap'>
                                    <div className='schedule-control-booking-information-item-wrap'>
                                        <h5>{'Booking information'.translate(this.props.lang)}</h5>
                                        <h6>{this.state.data?.templateData?.selectedAvailabilityTemplate?.visitTypeName} <span className='no-space-wrap-text'>({this.state.data?.templateData?.selectedAvailabilityTemplate?.duration} {'min'.translate(this.props.lang)})</span></h6>
                                    </div>
                                    <div className='schedule-control-booking-information-item-wrap'>
                                        <h6>{this.state.data?.templateData?.date}</h6>
                                        <h6>{this.state.data?.templateData?.startTime !== this.state.data?.startTime || this.state.data?.templateData?.endTime !== this.state.data?.endTime ? <span>{`${this.state.data?.templateData?.startTime} - ${this.state.data?.templateData?.endTime}`}</span> : null}{isTimeValidString(this.state.data?.startTime) && isTimeValidString(this.state.data?.endTime) ? `${this.state.data?.startTime} - ${this.state.data?.endTime}` : 'Wrong time input'.translate(this.props.lang)}</h6>
                                    </div>
                                </div>
                                :
                                null
                        }

                        {
                            isChild ?
                                <FormGroup>
                                    <Label style={{ color: 'red' }}>{msg2}</Label>
                                </FormGroup>
                                :
                                null
                        }
                        {
                            isChild ?
                                <FormGroup>
                                    <Label style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{"Parent/legal guardian added to appointment".translate(this.props.lang)} <div className="parent-tooltip"> <Isvg src={infoIcon} className="info-text" /> <div className="chat-icons-tooltip">{'Appointment can be managed by one or two parents/legal guardians. Selected persons will receive notification and can participate in chat and videocalls'.translate(this.props.lang)}</div> </div></Label>
                                    {
                                        patientData?.parentObj?.socialSecurityNumber && patientData?.parentObj2?.socialSecurityNumber ?
                                            <div className='table-parents-wrap'>
                                                <table className='table-parents'>
                                                    <tr>
                                                        <td>
                                                            <Checkbox
                                                                checked={this.state.data?.selectedParents?.indexOf(patientData?.parentObj?._id) !== -1 ? true : false} onChange={(e) => {
                                                                    let data = this.state.data;
                                                                    let selectedParents = data.selectedParents ?? [];
                                                                    let parentId;
                                                                    if (patientData?.parentObj?._id) {
                                                                        parentId = patientData.parentObj._id;
                                                                    }
                                                                    if (e.target.checked) {
                                                                        if (parentId && selectedParents.indexOf(parentId) === -1) {
                                                                            selectedParents.push(parentId)
                                                                        }
                                                                    } else {
                                                                        if (parentId && selectedParents.indexOf(parentId) !== -1 && selectedParents.length > 1) {
                                                                            let index = selectedParents.indexOf(parentId);
                                                                            selectedParents.splice(index, 1)
                                                                        }
                                                                    }
                                                                    data.selectedParents = selectedParents;
                                                                    let parents = [];

                                                                    for (let i = 0; i < selectedParents.length; i++) {
                                                                        if (patientData?.parentObj?._id === selectedParents[i] && patientData?.parentObj?.name) {
                                                                            parents.push(patientData.parentObj.name.trim())
                                                                        }
                                                                        if (patientData?.parentObj2?._id === selectedParents[i] && patientData?.parentObj2?.name) {
                                                                            parents.push(patientData.parentObj2.name.trim())
                                                                        }
                                                                    }

                                                                    data.title = patientData.userData.name.trim() + ' ' + 'Parent/legal guardian:'.translate(this.props.lang) + ` ${parents.join(', ')}`;

                                                                    this.setState({ data })

                                                                }} />
                                                        </td>
                                                        <td>{patientData && patientData.parentObj && patientData.parentObj.name}</td>
                                                        <td>{patientData && patientData.parentObj && patientData.parentObj.socialSecurityNumber}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Checkbox
                                                                checked={this.state.data?.selectedParents?.indexOf(patientData?.parentObj2?._id) !== -1 ? true : false} onChange={(e) => {
                                                                    let data = this.state.data;
                                                                    let selectedParents = data.selectedParents ?? [];
                                                                    let parentId;
                                                                    if (patientData?.parentObj2?._id) {
                                                                        parentId = patientData.parentObj2._id;
                                                                    }
                                                                    if (e.target.checked) {
                                                                        if (parentId && selectedParents.indexOf(parentId) === -1) {
                                                                            selectedParents.push(parentId)
                                                                        }
                                                                    } else {
                                                                        if (parentId && selectedParents.indexOf(parentId) !== -1 && selectedParents.length > 1) {
                                                                            let index = selectedParents.indexOf(parentId);
                                                                            selectedParents.splice(index, 1)
                                                                        }
                                                                    }
                                                                    data.selectedParents = selectedParents;
                                                                    let parents = [];

                                                                    for (let i = 0; i < selectedParents.length; i++) {
                                                                        if (patientData?.parentObj?._id === selectedParents[i] && patientData?.parentObj?.name) {
                                                                            parents.push(patientData.parentObj.name.trim())
                                                                        }
                                                                        if (patientData?.parentObj2?._id === selectedParents[i] && patientData?.parentObj2?.name) {
                                                                            parents.push(patientData.parentObj2.name.trim())
                                                                        }
                                                                    }

                                                                    data.title = patientData.userData.name.trim() + ' ' + 'Parent/legal guardian:'.translate(this.props.lang) + ` ${parents.join(', ')}`;


                                                                    this.setState({ data })
                                                                }} />
                                                        </td>
                                                        <td>{patientData && patientData.parentObj2 && patientData.parentObj2.name}</td>
                                                        <td>{patientData && patientData.parentObj2 && patientData.parentObj2.socialSecurityNumber}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            :
                                            <div>
                                                <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                                                    <p>{patientData && patientData.parentObj && patientData.parentObj.name}</p>
                                                    <p>{patientData && patientData.parentObj && patientData.parentObj.socialSecurityNumber}</p>
                                                </div>
                                                <div className='add-second-guardian-btn'>
                                                    <Button color='primary' onClick={() => {
                                                        let patientObj = JSON.parse(JSON.stringify(patientData))
                                                        this.setState({ addSecondGuardian: patientObj })
                                                    }}>{'Add second parent/legal guardian'.translate(this.props.lang)}</Button>
                                                </div>
                                            </div>
                                    }


                                </FormGroup>
                                :
                                null
                        }
                        {
                            isChild && this.state.data && this.state.data.title ?
                                <FormGroup>
                                    <div className='patient-no-notif-modal'>
                                        <Label>{'Title'.translate(this.props.lang)}</Label>
                                        {
                                            !patientData?.phone && !patientData?.email ?
                                                <div className='patient-no-notif'>
                                                    <Isvg src={noNotifications} width={20} height={20} />
                                                    <div>
                                                        {'Phone and email not registered'.translate(this.props.lang)}
                                                    </div>
                                                    <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>

                                    <Input
                                        disabled
                                        type='textarea'
                                        value={this.state.data.titleDoctor && this.state.data.titleDoctor != '' ?
                                            `Patient: ${this.state.data.title}, ${doctorData?.name || ''}${this.state.data.visitReasonName && this.state.data.visitReasonName != '' ? ', (' + this.state.data.visitReasonName + ')' : ''}` + ', ' + `${doctorData?.name || ''}` :
                                            `Patient: ${this.state.data.title}, ${doctorData?.name || ''}${this.state.data.visitReasonName && this.state.data.visitReasonName != '' ? ', (' + this.state.data.visitReasonName + ')' : ''}`} />

                                    <Input type='text' style={{ marginTop: 5 }}
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.titleDoctor = striptags(e.target.value);
                                            this.setState({
                                                data
                                            })
                                        }}
                                        value={this.state.data.titleDoctor}
                                    />

                                </FormGroup>

                                :

                                this.state.data && this.state.data.title ?
                                    <FormGroup>
                                        <div className='patient-no-notif-modal'>
                                            <Label>{'Title'.translate(this.props.lang)}</Label>
                                            {
                                                !patientData?.phone && !patientData?.email ?
                                                    <div className='patient-no-notif'>
                                                        <Isvg src={noNotifications} width={20} height={20} />
                                                        <div>
                                                            {'Phone and email not registered'.translate(this.props.lang)}
                                                        </div>
                                                        <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>

                                        <Input
                                            disabled
                                            type='textarea'
                                            value={
                                                this.state.data.titleDoctor && this.state.data.titleDoctor != '' ?
                                                    `Patient: ${this.state.data.title}, ${doctorData?.name || ''}${this.state.data.visitReasonName && this.state.data.visitReasonName != '' ?
                                                        ', (' + this.state.data.visitReasonName + ')' : ''}` + ', ' + this.state.data.titleDoctor
                                                    :
                                                    `Patient: ${this.state.data.title}, ${doctorData?.name || ''}${this.state.data.visitReasonName && this.state.data.visitReasonName != '' ?
                                                        ', (' + this.state.data.visitReasonName + ')' : ''}`
                                            }
                                        />
                                        <Input
                                            type='text'
                                            style={{ marginTop: 5 }}
                                            onChange={(e) => {
                                                let data = this.state.data;
                                                data.titleDoctor = striptags(e.target.value);
                                                this.setState({
                                                    data
                                                })
                                            }}
                                            value={this.state.data.titleDoctor}
                                        />

                                    </FormGroup>
                                    :
                                    null

                        }

                        {
                            !this.state.data?.templateData?.selectedAvailabilityTemplate?._id ?
                                <DatePicker
                                    label={'Date'.translate(this.props.lang)}
                                    value={this.state.data.date}
                                    holidayEvents={this.state.holidayEvents}
                                    onChange={(e) => {
                                        let data = this.state.data;
                                        data.date = e;
                                        this.setState({
                                            data
                                        })
                                        if (Math.floor(new Date(this.state.data.date + ' ' + this.state.data.startTime) / 1000) > Math.floor(new Date(this.state.data.endDate + ' ' + this.state.data.endTime) / 1000)) {
                                            data.endDate = this.state.data.date
                                            this.setState({
                                                data
                                            })
                                        }
                                    }}
                                />
                                :
                                null
                        }

                        <div className={this.state.data?.templateData?.selectedAvailabilityTemplate?._id ? 'schedule-control-time-wrap-template' : ''}>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'Start time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePickerV2
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={this.state.data.startTime}
                                    // minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')}
                                    // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')}
                                    minValue={minTime}
                                    maxValue={addMinutesToTime(maxTime, -5)}
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let data = this.state.data;
                                        data.startTime = timeString


                                        let startTimeSplit = data.startTime.split(":");
                                        let endTimeSplit = data.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ data })
                                        } else {
                                            data.endTime = Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60
                                            const padded = data?.endTime?.split?.(':');
                                            if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                const h = padded[0]?.padStart?.(2, '0');
                                                const m = padded[1]?.padStart?.(2, '0');
                                                if (h && m) data.endTime = `${h}:${m}`;
                                            }
                                            this.setState({
                                                data
                                            })
                                        }
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'End time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePickerV2
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={this.state.data.endTime}
                                    minValue={Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60}
                                    // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')}
                                    maxValue={maxTime}
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let data = this.state.data;
                                        data.endTime = timeString

                                        let startTimeSplit = data.startTime.split(":");
                                        let endTimeSplit = data.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ data })
                                        }
                                    }}
                                />

                            </FormGroup>
                        </div>
                        {
                            this.state.data.title ?
                                <FormGroup>
                                    <Label className='note-label-wrap'>{this.state.data?.templateData?.selectedAvailabilityTemplate?._id ? 'Internal note'.translate(this.props.lang) : 'Note'.translate(this.props.lang)}
                                        {/* <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                        </div> */}
                                    </Label>
                                    <Input type='textarea'
                                        name="note"
                                        style={{ height: '150px' }}
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.patientControlNote = striptags(e.target.value);
                                            this.setState({
                                                data
                                            })
                                        }}
                                        value={this.state.data.patientControlNote}
                                    />
                                </FormGroup>
                                :
                                null
                        }
                        {
                            this.state.data.title && this.state.data?.templateData?.selectedAvailabilityTemplate?._id ?
                                <FormGroup>
                                    <Label style={{ display: 'flex', alignItems: 'center' }}>
                                        {'Note to patient'.translate(this.props.lang)}
                                        <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                            <Isvg src={infoIcon} style={{ width: 25 }} />
                                            <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'This information wiil be shown to patient in ther booking information in "My cases"'.translate(this.props.lang)}</div>
                                        </div>
                                    </Label>
                                    <Input type='textarea'
                                        name="noteToPatient"
                                        style={{ height: '110px' }}
                                        onChange={(e) => {
                                            let value = striptags(e.target.value);
                                            if (value?.length <= 160) {
                                                let data = this.state.data;
                                                data.noteToPatient = value;
                                                if (value?.trim() === '') {
                                                    data.sendNoteAsPatientNotification = false;
                                                }
                                                this.setState({
                                                    data
                                                })
                                            }

                                        }}
                                        value={this.state.data.noteToPatient}
                                    />
                                </FormGroup>
                                :
                                null
                        }
                        {
                            this.state.data.title && this.state.data?.templateData?.selectedAvailabilityTemplate?._id ?
                                <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        onChange={(e) => {
                                            if (!this.state.data?.noteToPatient || this.state.data?.noteToPatient?.trim() === '') return;
                                            let data = this.state.data;
                                            data.sendNoteAsPatientNotification = e.target.checked;
                                            this.setState({
                                                data
                                            })
                                        }}
                                        disabled={!this.state.data?.noteToPatient || this.state.data?.noteToPatient?.trim() === '' ? true : false}
                                        checked={this.state.data?.noteToPatient?.trim() === '' ? false : this.state.data.sendNoteAsPatientNotification}
                                        label={'Send note as patient notification'.translate(this.props.lang)}
                                    />
                                    <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                        <Isvg src={infoIcon} style={{ width: 25 }} />
                                        <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'By checking box the note to patient will also be sent as a separate notification to the patient'.translate(this.props.lang)}</div>
                                    </div>
                                </FormGroup>
                                :
                                null
                        }
                        {
                            this.state.data.title && enterprise ?
                                <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.hideTimeFromThePatient = e.target.checked;
                                            if (data.hideTimeFromThePatient) {
                                                data.hideDurationForPatient = true;
                                            }
                                            this.setState({
                                                data
                                            })
                                        }}
                                        checked={this.state.data.hideTimeFromThePatient}
                                        label={'Hide time from the patient'.translate(this.props.lang)}
                                    />
                                    <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                        <Isvg src={infoIcon} style={{ width: 25 }} />
                                        <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Time is not displayed to the patient.'.translate(this.props.lang)}</div>
                                    </div>
                                </FormGroup>
                                :
                                null
                        }
                        {
                            this.state.data.title /*&& enterprise*/ ?
                                <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        onChange={(e) => {
                                            if (this.state.data?.hideTimeFromThePatient) return;
                                            let data = this.state.data;
                                            data.hideDurationForPatient = e.target.checked;
                                            this.setState({
                                                data
                                            })
                                        }}
                                        disabled={this.state.data.hideTimeFromThePatient ? true : false}
                                        checked={this.state.data.hideDurationForPatient}
                                        label={'Hide duration for patient'.translate(this.props.lang)}
                                    />
                                    <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                        <Isvg src={infoIcon} style={{ width: 25 }} />
                                        <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Duration is not displayed to the patient.'.translate(this.props.lang)}</div>
                                    </div>
                                </FormGroup>
                                :
                                null
                        }


                        {
                            this.state.data.title && enterprise ?
                                <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.closeCaseManually = e.target.checked;
                                            this.setState({
                                                data
                                            })
                                        }}
                                        checked={this.state.data.closeCaseManually}
                                        label={'Close case manually'.translate(this.props.lang)}
                                    />

                                </FormGroup>
                                :
                                null
                        }


                        {
                            this.state.data.title ?
                                <FormGroup>
                                    {
                                        !this.state.data?.templateData?.selectedAvailabilityTemplate?._id ?
                                            <Button onClick={() => this.setState({
                                                selectVisitReason: true
                                            })} color="primary">
                                                {'Select a visit reason'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }
                                    {
                                        enterprise ?
                                            <Button disabled={!this.state.data?.visiReason} style={{ marginLeft: this.state.data?.templateData?.selectedAvailabilityTemplate?._id ? 0 : 10 }}
                                                onClick={() => {

                                                    this.setState({
                                                        selectRevisitForm: true,
                                                        revisitFormsSelect: this.state.revisitFormsSelected ? [...this.state.revisitFormsSelected] : [],
                                                        journalNoteForm: this.state.journalNoteFormSelected ? this.state.journalNoteFormSelected : null
                                                    })
                                                }}
                                                color="primary"
                                            >
                                                {'Insert form'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }

                                </FormGroup>
                                :
                                null
                        }
                        {
                            this.state.data.title && enterprise && this.state.revisitFormsSelected?.length ?
                                <FormGroup className='attached-forms-wrap'>
                                    <Label>{'Attached forms'.translate(this.props.lang)}</Label>
                                    <ul>
                                        {
                                            this.state.revisitFormsSelected.map((item, idx) => {
                                                let revisitForms = this.state.revisitForms?.items ? this.state.revisitForms.items : [];
                                                let formName = revisitForms.filter(el => el && el._id === item).length ? revisitForms.filter(el => el._id === item)[0].name : null;
                                                if (formName)
                                                    return (
                                                        <li className="attached-forms-item">
                                                            {formName}
                                                        </li>
                                                    )
                                            })
                                        }
                                    </ul>

                                </FormGroup>
                                :
                                null
                        }


                        {
                            this.state.data.title && !this.state.data?.templateData?.selectedAvailabilityTemplate?._id ?
                                <FormGroup>
                                    <Label>{'Visit reason'.translate(this.props.lang)}</Label>
                                    <Input disabled type='text' value={this.state.data.visitReasonName ? this.state.data.visitReasonName : ''} />
                                </FormGroup>
                                :
                                null
                        }
                        {
                            this.state.data.title /*&& !this.state.data?.templateData?.selectedAvailabilityTemplate?._id*/ ?
                                <FormGroup>
                                    <Label>{'Price'.translate(this.props.lang)}</Label>
                                    <Input
                                        disabled={this.state.data.visitReasonName && EXTENDED_PAYMENT_MANAGEMENT ? false : true}
                                        type='text'
                                        value={this.state.data.visitReasonPrice}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            let data = this.state.data;
                                            data.visitReasonPrice = Number(value);
                                            this.setState({ isPaymentMethodErrorShow: false, showPaymentMethodError: false }, () => {
                                                this.setState({ data });
                                            })
                                        }}
                                    />
                                </FormGroup>
                                :
                                null
                        }
                        {
                            Number(this.state.data.visitReasonPrice) > 0 && Number(this.state.data._visitReasonPrice) === 0 ?
                                <PaymentMethodsField
                                    {...this.props}
                                    onChange={(_data) => {
                                        let data = this.state.data;
                                        data.paymentMethods = _data.paymentMethods ?? [];
                                        data.attachedInvoice = _data?.attachedInvoice ?? null;
                                        let setObj = { data, showPaymentMethodError: false };
                                        setObj.isPaymentMethodErrorShow = _data?.errors ? true : false;
                                        this.setState(setObj);
                                    }}
                                    showError={this.state.showPaymentMethodError}
                                    price={this.state.data.visitReasonPrice}
                                />
                                :
                                null
                        }



                        <div className='calendar-modal-buttons-wrap'>
                            {
                                this.state.data.title ?
                                    <FormGroup>
                                        <Button onClick={() => this.setState({
                                            doctorsModal: 3
                                        })} color="primary">
                                            {'Add caregiver'.translate(this.props.lang)}
                                        </Button>
                                    </FormGroup>
                                    :
                                    null
                            }
                            {
                                this.state.data.title && eventMeetings ?
                                    <FormGroup>
                                        <Button
                                            onClick={() => {
                                                let guests = [];
                                                if (this.state.data?.guests) {
                                                    guests = [...this.state.data.guests];
                                                }
                                                this.setState({
                                                    eventMeetingsModal: { ...this.state.data, guests, modal: 'control' }
                                                })
                                            }}
                                            color="primary"
                                        >
                                            {'Add guest'.translate(this.props.lang)}
                                        </Button>
                                    </FormGroup>

                                    :

                                    null
                            }
                        </div>


                        <Button
                            color='primary'
                            disabled={this.state.data.title && this.state.data.visitReasonName && !this.state.creatingEvent && this.state.doctorId ? false : true}
                            onClick={() => this.setState({
                                creatingEvent: true
                            }, () => this.scheduleControl(this.state.data))}
                        >
                            {'Schedule control'.translate(this.props.lang)}
                        </Button>

                    </ModalBody>
                </Modal>
                {
                    this.state.showPatientNotes ?
                        <PatientNotesPreview
                            {...this.props}
                            isOpen={this.state.showPatientNotes}
                            items={this.state.patientNotes}
                            toggle={() => this.setState({ showPatientNotes: !this.state.showPatientNotes })}
                            showInModal={true}
                        />
                        :
                        null
                }

                {
                    this.state.successfullyAdditionalDoctors ?
                        <InfoModal
                            isOpen={this.state.successfullyAdditionalDoctors}
                            toggle={() => this.setState({ successfullyAdditionalDoctors: !this.state.successfullyAdditionalDoctors })}
                            header={'Info'.translate(this.props.lang)}
                            info={`All doctors were successfully added`.translate(this.props.lang)}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ successfullyAdditionalDoctors: false })}>{'Ok'.translate(this.props.lang)}</Button>,

                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.doctorsModal ?
                        <Modal isOpen={this.state.doctorsModal} centered toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} >
                            <ModalHeader toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ doctorsModal: !this.state.doctorsModal })}><Isvg src={xIcon} /></button>}>{'Choose doctors'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody className="run-modal">

                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <FormGroup >
                                            <Label>{'Search'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.state.filterDoctors ? this.state.filterDoctors : ''} onChange={(e) => {
                                                this.setState({
                                                    filterDoctors: e.target.value
                                                })
                                            }} />

                                        </FormGroup>
                                        :
                                        null
                                }

                                <FormGroup >
                                    {
                                        this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                            if (item._id != this.state.doctorId) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }).length ?
                                            <DoctorListComponent

                                                value={this.state.doctorsList ? this.state.doctorsList : []}
                                                values={this.state.doctors.filter(el =>
                                                    (!this.state.updateEvent || (this.state.updateEvent && this.state.updateEvent.patientId != el._id))
                                                    && (!this.state.scheduleReferral || (this.state.scheduleReferral && this.state.referralId && this.state.referrals.filter(ref => ref._id == this.state.referralId) && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0] && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0].patientId != el._id))
                                                    && (!this.state.data || (this.state.data && this.state.data.patient != el._id))
                                                ).sort((a, b) => {
                                                    const nameA = a.name;
                                                    const nameB = b.name;
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).filter(doc => doc._id !== this.state.doctorId && doc.name.toLowerCase().indexOf(this.state.filterDoctors ? this.state.filterDoctors.toLowerCase() : ' ') != -1).map(item => {
                                                    return ({
                                                        name: item.name,
                                                        value: item._id,
                                                        profilePicture: item.profilePicture,
                                                        username: item.username
                                                    })
                                                })}
                                                onChange={(item) => {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = [...item]
                                                    this.setState({ doctorsList })
                                                }}
                                            />

                                            :
                                            "The doctor's list is empty".translate(this.props.lang)
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <Button color='primary'
                                            onClick={() =>
                                                this.checkDoctorsAvailable(this.state.doctorsList, this.state.doctorsModal)
                                            }>{'Add'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }
                                <Button color='primary' onClick={() => {
                                    this.setState({ doctorsModal: false })
                                }
                                }>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.selectRevisitForm ?
                        <Modal isOpen={this.state.selectRevisitForm} size="lg" centered >
                            <ModalHeader toggle={() => this.setState({ selectRevisitForm: !this.state.selectRevisitForm })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ selectRevisitForm: !this.state.selectRevisitForm })}>&times;</button>}>{'Revisit forms'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <div className="search-box-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <FormGroup>
                                        <Label>{'Search'.translate(this.props.lang)}</Label>
                                        <Input value={this.state.searchRevisitForm}
                                            onChange={(e) => {
                                                this.setState({ searchRevisitForm: striptags(e.target.value) }, () => this.getRevisitQuestionary())
                                            }}
                                        />
                                    </FormGroup>
                                    <Button color="primary" onClick={() => {
                                        if (this.state.revisitForms && this.state.revisitForms.items && this.state.revisitForms.items.length) {
                                            let revisitFormsSelect = [];
                                            let journalNoteForm = this.state.journalNoteForm ? this.state.journalNoteForm : null;
                                            for (let i = 0; i < this.state.revisitForms.items.length; i++) {
                                                revisitFormsSelect.push(this.state.revisitForms.items[i]._id)
                                                if (!journalNoteForm) {
                                                    journalNoteForm = this.state.revisitForms.items[i]._id;
                                                }
                                            }
                                            this.setState({ revisitFormsSelect, journalNoteForm })
                                        }
                                    }}>{'Mark all'.translate(this.props.lang)}</Button>
                                </div>
                                <div className="general-health-care-wrap">
                                    {
                                        this.state.revisitForms && this.state.revisitForms.items && this.state.revisitForms.items.map((item, idx) => {
                                            return (
                                                <div className="health-care-wrap">
                                                    <div className="content">
                                                        <div className="title">
                                                            {item.name}
                                                            <span>
                                                                &nbsp;&nbsp;/&nbsp;&nbsp;
                                                                {item.description}</span>
                                                        </div>

                                                    </div>
                                                    <div className='checkbox-wrap'>
                                                        <Checkbox
                                                            onChange={(e) => {
                                                                let val = e.target.checked;
                                                                let revisitFormsSelect = this.state.revisitFormsSelect;
                                                                let journalNoteForm = this.state.journalNoteForm ? this.state.journalNoteForm : null;
                                                                if (val && revisitFormsSelect.filter(el => el == item._id).length == 0) {
                                                                    revisitFormsSelect.push(item._id)
                                                                    if (!journalNoteForm) {
                                                                        journalNoteForm = item._id;
                                                                    }
                                                                } else if (!val && revisitFormsSelect.filter(el => el == item._id).length) {
                                                                    let index = revisitFormsSelect.findIndex(el => el == item._id)
                                                                    if (index > -1) {
                                                                        revisitFormsSelect.splice(index, 1)
                                                                    }
                                                                    if (journalNoteForm && journalNoteForm == item._id) {
                                                                        let check = null;
                                                                        if (revisitFormsSelect && revisitFormsSelect.filter(el => el != item._id).length) {
                                                                            check = revisitFormsSelect.filter(el => el != item._id)[0];
                                                                        }
                                                                        journalNoteForm = check;
                                                                    }
                                                                }
                                                                this.setState({
                                                                    revisitFormsSelect,
                                                                    journalNoteForm
                                                                })
                                                            }}
                                                            checked={this.state.revisitFormsSelect.filter(el => el == item._id).length ? true : false}
                                                        />
                                                        <div className='use-in-journal-notes-checkbox'>
                                                            {
                                                                this.state.revisitFormsSelect.filter(el => el == item._id).length ?
                                                                    <Checkbox
                                                                        label={'Use in Journal notes'.translate(this.props.lang)}
                                                                        onChange={(e) => {
                                                                            let val = e.target.checked;
                                                                            let journalNoteForm = this.state.journalNoteForm;
                                                                            if (val) {
                                                                                journalNoteForm = item._id;
                                                                            }
                                                                            this.setState({
                                                                                journalNoteForm
                                                                            })
                                                                        }}
                                                                        checked={this.state.journalNoteForm == item._id ? true : false}
                                                                    />
                                                                    :
                                                                    null
                                                            }
                                                        </div>


                                                    </div>


                                                </div>
                                            )
                                        })
                                    }
                                </div>


                            </ModalBody>

                            <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }} className='buttons-right-blue'>
                                <Button color="primary" onClick={() => {
                                    let revisitFormsSelect = this.state.revisitFormsSelect;
                                    let journalNoteForm = this.state.journalNoteForm;
                                    this.setState({ selectRevisitForm: null, revisitFormsSelected: revisitFormsSelect, revisitFormsSelect: [], journalNoteFormSelected: journalNoteForm, journalNoteForm: null })
                                }}> {'Insert'.translate(this.props.lang)} </Button>
                                <Button color="primary" onClick={() => this.setState({ selectRevisitForm: null, revisitFormsSelect: [] })}> {'Cancel'.translate(this.props.lang)} </Button>

                            </ModalFooter>



                        </Modal>
                        :
                        null
                }

                {
                    this.state.addSecondGuardian ?
                        <AddSecondParentModal
                            {...this.props}
                            languages={this.state.languages}
                            data={this.state.addSecondGuardian}
                            close={(getPatientData) => this.setState({ addSecondGuardian: null }, () => {
                                if (getPatientData) {
                                    let ssn = patientData?.socialSecurityNumber;
                                    this.findPatient(ssn)
                                }
                            })}
                        />
                        :
                        null
                }

                {
                    this.state.eventMeetingsModal ?
                        <EventMeetingsModal
                            {...this.props}
                            data={this.state.eventMeetingsModal}
                            doctorId={this.state.doctorId}
                            onClose={() => this.setState({ eventMeetingsModal: null })}
                            closeButtonText={'Close without saving'.translate(this.props.lang)}
                            saveData={(data) => {
                                let setObj = { eventMeetingsModal: null };
                                let modal = this.state.eventMeetingsModal?.modal;
                                if (data && modal) {
                                    if (modal === 'control') {
                                        let eventObj = this.state.data;
                                        eventObj.guests = data;
                                        this.setData(eventObj)
                                    }
                                }
                                this.setState(setObj)
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.errorOverlap ?
                        <Modal
                            isOpen={this.state.errorOverlap}
                            centered
                        >
                            <ModalBody className="delete-modal">
                                <div className='message'>
                                    {'Bookings in your calendar already exist for the selected period'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    color='primary'
                                    disabled={this.state.loadingUpdate}
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        const data = this.state.errorOverlap?.data;
                                        const _data = this.state.errorOverlap?._data;
                                        const updateAllRecurringEvents = this.state.errorOverlap?.updateAllRecurringEvents;
                                        if (data) {
                                            this.updateEventTypeEvent(data, updateAllRecurringEvents, true)
                                        } else if (_data) {
                                            this.scheduleEvent(_data, true)
                                        }
                                    }}>
                                    {'Continue anyways'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    disabled={this.state.loadingUpdate}
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        this.setState({
                                            errorOverlap: null
                                        })
                                    }}>{'Go back'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            <ModalBody className="delete-modal">
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {
                                this.setState({ errorAdditionalDoctors: null })
                            }}

                        >
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>

                                            {
                                                item.available ?
                                                    <span style={{ color: 'green' }}>{'Available'.translate(this.props.lang)}</span>
                                                    :
                                                    <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                            }

                                        </div>
                                    )
                                })

                            }
                        </ErrorModal>
                        :
                        null
                }
                {
                    this.state.noteToPatientPreScheduleInfo ?
                        <Modal isOpen={this.state.noteToPatientPreScheduleInfo} centered >
                            <ModalBody className="delete-modal">
                                <div className='message'>{'Are you sure you also want to send the note as a notification? Depending on the content of your note and your settings, sensitive information might be shared via SMS/email/push.'.translate(this.props.lang)}</div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }}
                                    disabled={this.state.loading}
                                    onClick={() => {
                                        const data = this.state.noteToPatientPreScheduleInfo?.data;
                                        if (data) {
                                            this.setState({ noteToPatientPreScheduleInfo: null }, () => {
                                                this.scheduleControl(data, true)
                                            });
                                        }
                                    }}>
                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loading) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Continue'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    this.setState({
                                        noteToPatientPreScheduleInfo: !this.state.noteToPatientPreScheduleInfo,
                                        creatingEvent: false
                                    })
                                }}>{'Go back'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.invoiceMessage ?
                        <InfoModal
                            isOpen={this.state.invoiceMessage}
                            onClose={(item) => {
                                this.setState({
                                    invoiceMessage: item
                                })
                            }}
                            info={this.state.invoiceMessage.translate(this.props.lang)}
                            buttons={[
                                <Button
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.props[0].history.push('/my-data/clinic/payments')}
                                >
                                    {"Go to payment".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {
                                        this.setState({
                                            invoiceMessage: null
                                        }, () => {
                                            this.toggle();
                                        })
                                    }}
                                >
                                    {'Close'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }
                {
                    this.state.selectVisitReason ?
                        <Modal isOpen={this.state.selectVisitReason} size="lg" centered >
                            <ModalHeader toggle={() => this.setState({ selectVisitReason: !this.state.selectVisitReason })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ selectVisitReason: !this.state.selectVisitReason })}>&times;</button>}>{'Visit reasons'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <div className="search-box-wrap">
                                    <FormGroup>
                                        <Label>{'Search'.translate(this.props.lang)}</Label>
                                        <Input value={this.state.searchVisitReason}
                                            onChange={(e) => {
                                                this.setState({ searchVisitReason: striptags(e.target.value) }, () => this.getPriceList())
                                            }}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="general-health-care-wrap">
                                    {
                                        this.state.visitReasons && this.state.visitReasons.items && this.state.visitReasons.items.sort((a, b) => {
                                            const nameA = a.name;
                                            const nameB = b.name;
                                            if (nameA < nameB) {
                                                return -1
                                            }
                                            if (nameA > nameB) {
                                                return 1
                                            }
                                        }).map((item, idx) => {
                                            return (
                                                <div className="health-care-wrap">
                                                    <div className="content">
                                                        <div className="title">
                                                            {item.name}
                                                            <span>
                                                                &nbsp;&nbsp;/&nbsp;&nbsp;
                                                                {item.description}</span>
                                                        </div>

                                                    </div>
                                                    <Button color='primary' onClick={() => {
                                                        let data = this.state.data;
                                                        data.visitReasonName = item.name;
                                                        if (this.state.age && item.under18 && this.state.age < 18) {
                                                            data.visitReasonPrice = 0;
                                                            data.freePayment = 4
                                                        } else if (this.state.age && item.under20 && this.state.age < 20) {
                                                            data.visitReasonPrice = 0;
                                                            data.freePayment = 3
                                                        } else if (this.state.age && item.under23 && this.state.age < 23) {
                                                            data.visitReasonPrice = 0;
                                                            data.freePayment = 2
                                                        } else if (this.state.age && item.under18child && this.state.age < 18) {
                                                            data.visitReasonPrice = 0;
                                                            data.freePayment = 6
                                                        } else if (this.state.age && item.older85 && this.state.age > 85) {
                                                            data.visitReasonPrice = 0;
                                                            data.freePayment = 5
                                                        } else {
                                                            data.visitReasonPrice = item.price;
                                                        }
                                                        data._visitReasonPrice = Number(data.visitReasonPrice);

                                                        data.visiReason = item._id;
                                                        data.visitReasonOnline = item.onlineVisit;
                                                        data.videoCall = item.videoCall;
                                                        let setObj = { selectVisitReason: false, data }
                                                        let revisitFormsSelected = [];
                                                        let journalNoteFormSelected = null;

                                                        if (enterprise && item && item.defaultForm && this.state.revisitForms && this.state.revisitForms.items?.filter(el => el._id === item.defaultForm).length) {
                                                            revisitFormsSelected.push(item.defaultForm);
                                                            journalNoteFormSelected = item.defaultForm;

                                                        }
                                                        setObj.journalNoteFormSelected = journalNoteFormSelected;
                                                        setObj.revisitFormsSelected = revisitFormsSelected;
                                                        this.setState(setObj)
                                                    }}>{'Select'.translate(this.props.lang)}</Button>

                                                </div>
                                            )
                                        })
                                    }
                                </div>


                            </ModalBody>

                            <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }}>

                                <Button color="primary" onClick={() => this.setState({ selectVisitReason: null })}> {'Close'.translate(this.props.lang)} </Button>

                            </ModalFooter>



                        </Modal>
                        :
                        null
                }

            </>


        )
    }
}

export default ScheduleControl;